<template>
<v-row justify="center">
  <v-dialog v-model="DetailFriendDialog" persistent max-width="320" style="overflow: hidden !important;">
    <v-card :style="stylechat">
      <v-card-title class="pa-3">
        <v-spacer></v-spacer>
        <v-icon class="color-btn pr-2" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="12" justify="center" align="center">
            <v-avatar
              size="60"
            >
            <img v-if="InforFriend.profilepicture" :src="InforFriend.profilepicture" alt="" class="img-position">
            <img v-else-if="InforFriend.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
            <img v-else-if="InforFriend.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
            <img v-else-if="InforFriend.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
            <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
            </v-avatar>
          </v-col>
          <v-col cols="12" justify="center" align="center">
            <p class="font-title text-overflow">{{InforFriend.name}}</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-flex xs6 md6 sm6>
          <v-btn text block class="color-btn" @click="toPage('/profilefriend', InforFriend.tokenuser)">
            <v-icon class="color-btn pr-2">fa-solid fa-address-card</v-icon>
            {{$t('Dialog.profilefriend.headerProfile')}}
          </v-btn>
        </v-flex>
        <v-flex xs6 md6 sm6>
          <v-btn text block class="color-btn" :loading="loading" @click="checkState(InforFriend.statemember)">
            <v-icon class="color-btn pr-2">{{icon}}</v-icon>
            {{text_btn}}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </v-dialog>
</v-row>
</template>
<script>
import { sync } from 'vuex-pathify'
import ErrorDialog from '@/components/Alert/Error'
export default {
  props: {
    DetailFriendDialog: Boolean,
    InforFriend: {}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      loading: false,
      data_user: {},
      ErrorDialogDetail: {},
      ErrorDialog: false,
      text_btn: '',
      icon: '',
      stylechat: {
        "--DetailFriend-HeaderColor": "white",
        "--DetailFriend-TabBackground": "white",
        "--DetailFriend-Icon": "gray",
        "--DetailFriend-IconActive": "#2662ae",
        "--DetailFriend-Background": "white",
        "--DetailFriend-FontSize": "18px",
        "--DetailFriend-FontColor": "black",
        "--DetailFriend-FontSize-Status": "16px",
        "--DetailFriend-FontColor-Status": "grey",
        "--DetailFriend-Background-Input": "#E2E1E3",
        "--DetailFriend-Color-Button": "#EFF2FE",
        "--DetailFriend-FontColor-Button": "#2662ae"
      },
    }
  },
  components: {
    ErrorDialog
  },
  computed: {
    ...sync('*')
  },
  watch: {
    DetailFriendDialog() {
      if (this.DetailFriendDialog) {
        // console.log(this.InforFriend)
        // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
          user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
          user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
        this.checkFriend()
      }
    }
  },
  created() {
    // console.log('themechat', this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    // this.data_user = user_profile['account']['profile']
  },
  methods: {
    checkFriend () {
      if (this.InforFriend.statemember === 'friend') {
        this.text_btn = this.$t('AnswerQuestion.chat')
        this.icon = 'fa-solid fa-comment-dots'
      } else if (this.InforFriend.statemember === 'request') {
        this.text_btn = this.$t('AnswerQuestion.acceptFriend')
        this.icon = 'mdi-account-plus'
      } else if (this.InforFriend.statemember === 'sendrequest') {
        this.text_btn = this.$t('AnswerQuestion.cancelRequest')
        this.icon = 'mdi-account-minus'
      } else if (this.InforFriend.statemember === 'block') {
        this.text_btn = this.$t('AnswerQuestion.unblock')
        this.icon = 'mdi-lock-open'
      } else if (this.InforFriend.statemember === 'unknown' || this.InforFriend.statemember === 'unfriend') {
        this.text_btn = this.$t('AnswerQuestion.addFriend')
        this.icon = 'fa-solid fa-user-plus'
      } else {
        this.text_btn = this.$t('AnswerQuestion.ok')
        this.icon = 'mdi-account-circle'
      }
    },
    toPage (path, tokenuser) {
      this.$router.push(`/profile/friend/${tokenuser}`)
    },
    closeAlertDialog (item) {
      if (item.type === 'err') {
        this.ErrorDialog = false
      }
    },
    checkState (type) {
      // console.log('type: ', type)
      if (type === 'friend') {
        this.$cookie.set('select_menu', 2)
        this.$router.push(`/chat/${this.InforFriend.tokenroom}`)
        this.closeChatDialog()
      } else if (type === 'sendrequest') {
        // ยกเลิกคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/removerequestfriend`, {
          tokenfriend: this.InforFriend.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.closeDialog()
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (type === 'request') {
        // ตอบรับคำขอเป็นเพื่อน
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-friend`, {
          tokenfriend: this.InforFriend.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon = 'fa-solid fa-comment-dots'
            this.InforFriend.statemember = 'friend'
            this.InforFriend.tokenroom = response.data.tokenroom
            // this.closeDialog()
          } else {
            this.loading = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (type === 'block') {
        // unblock
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.InforFriend.tokenuser,
          tokenroom: this.InforFriend.tokenroom
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.InforFriend.statemember = 'friend'
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      } else if (type === 'unknown' || type === 'unfriend') {
        // add collap
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend-accept`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: this.InforFriend.tokenuser,
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon = 'fa-solid fa-comment-dots'
            this.InforFriend.statemember = 'friend'
            this.InforFriend.tokenroom = response.data.tokenroom
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    closeDialog() {
      this.$emit('closeDialog', {
        name: 'DetailFriend',
        value: false
      })
    },
    closeChatDialog() {
      this.$emit('closeDialog', {
        name: 'DetailFriendChat',
        value: false
      })
    },
  }
}
</script>
<style lang="css" scoped>
.text-overflow {
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  width: 250px !important;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.font-color-btn {
  color: var(--DetailFriend-FontColor-Button) !important;
}
.font-title {
  color: var(--DetailFriend-FontColor) !important;
  font-weight: 600 !important;
  font-size: var(--DetailFriend-FontSize) !important;
}
.color-btn {
  /* background-color: var(--DetailFriend-Color-Button) !important; */
  color: var(--DetailFriend-IconActive) !important;
  text-transform: none !important;
}
</style>
